<template>
  <base-input
    type="text"
    v-model="phone"
    ref="baseinput"
    :label="label"
    :valid="isValid"
    :masked="true"
    :mask="['(##) ####-####', '(##) #####-####']"
    :maxlength="15"
    :autocomplete="autocomplete"
    :disabled="disabled"
    @input="handleInput"
    @focus="onFocus()"
    @blur="validate()"
    :design="`${!!design ? `${design}` : ''}`"
  />
</template>

<script>
import BaseInput from "@/components/Input";
import { baseEvents } from "@/mixins/baseEvents.js";

export default {
  mixins: [baseEvents],
  components: {
    BaseInput,
  },
  props: {
    required: {type: Boolean, default: true },
    disabled: {type: Boolean, default: false },
    label: {type: String, default: 'Telefone' },
    autocomplete: {type: String, default: 'none' },
    design: String
  },
  mounted() {
    this.inputId = this.$refs.baseinput.id;
  },
  data() {
    return {
      phone: this.value || "",
      isValid: true,
      inputId: "",
    };
  },
  methods: {
    validate() {
      if(this.required || (this.phone && this.phone.length > 0)){
        this.isValid = false;

        if (!this.phone) {
          this.$parent.setErrorValidation(this.inputId, "3000", this.label);
          return;
        }

        if (!['7', '8', '9'].includes(this.phone.charAt(5)) && this.phone.length !== 14) {
          this.$parent.setErrorValidation(this.inputId, "3000", this.label);
          return;
        }

        if (['7', '8', '9'].includes(this.phone.charAt(5)) && this.phone.length !== 15) {
          this.$parent.setErrorValidation(this.inputId, "3001", this.label);
          return;
        }

        this.isValid = true;
      }
    },
    onFocus() {
      this.isValid = true;
      this.$parent.removeErrorValidation(this.inputId);
    },
    handleInput(e) {
      // Remove os caracteres especias da mask
      const phone = this.phone.replace(/[\(\)\-\ ]*/g, "");

      this.$emit("input", phone);
    },
  },
  watch: {
    value(newValue) {
      this.phone = newValue;
    }
  },
};
</script>